import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Doughnut } from "react-chartjs-2";
import WINHbA1cModal from "./WINHbA1cModal"; // Import the HbA1c modal component
import RedeemRewardsModal from "./RedeemRewardsModal";
import "./CircularProgress.css";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import badgeImage from "../../assets/images/badges/01-01.png"
import badgeImage13 from "../../assets/images/badges/01-01-gray.png"
import badgeImage1 from "../../assets/images/badges/01-02.png"
import badgeImage2 from "../../assets/images/badges/01-02-gray.png"
import badgeImage3 from "../../assets/images/badges/03-01.png"
import badgeImage4 from "../../assets/images/badges/03-01-gray.png"
import badgeImage5 from "../../assets/images/badges/02-07.png"
import badgeImage6 from "../../assets/images/badges/02-07-gray.png"
import badgeImage7 from "../../assets/images/badges/02-06.png"
import badgeImage8 from "../../assets/images/badges/02-06-gray.png"
import badgeImage9 from "../../assets/images/badges/03-01.png"
import badgeImage10 from "../../assets/images/badges/03-01-gray.png"
import badgeImage11 from "../../assets/images/badges/03-03.png"
import badgeImage12 from "../../assets/images/badges/03-03-gray.png"
import badgeImage15 from "../../assets/images/badges/02-01-gray.png"
import badgeImage14 from "../../assets/images/badges/02-01.png"

// Import Chart.js and register required elements
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import VitalsModal from "../Trackers/Tracker_Pregnancy/VitalsModal";
import { Endpoints } from "../../Global/Endpoints";

ChartJS.register(ArcElement, Tooltip, Legend);

const WinIncentiveLandingPage = ({ memberId, contract }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [rewardsData, setRewardsData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isRedeemModalOpen, setRedeemModalOpen] = useState(false); // State to manage RedeemRewardsModal
  const [email, setEmail] = useSelector((state) => state.email.email); // Email state
  const [amount, setAmount] = useState(0); // Amount state
  const token = localStorage.getItem("AccessToken") || "YOUR_ACCESS_TOKEN_HERE";
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
  const contractData = useSelector((state) => state.userData);
  const [isSeeVitalModalOpen, setIsSeeVitalModalOpen] = useState(false);

  useEffect(() => {
    const deviceType = "PatientPortal";
   

    fetchRewardsData();
  }, [memberId, contract, token, t]);

  const fetchRewardsData = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        Endpoints.GetWINRewardsTrackerDetails,
        `_Params=${encodeURIComponent(
          JSON.stringify({
            MemberID: contractData.userData.MemberID,
            Contract: contractData.userData.ContractIdentified,
            DeviceType:"PatientPortal",
            EmailID: contractData.userData.EmailID,
          })
        )}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );


      setRewardsData(response.data);
      console.log(response.data);
      // setEmail(response.data?.EmailID || "");
       setAmount(response.data?.TotalRewards || 0);
    } catch (error) {
      setError(t("errorfetchingdata"));
      toast.error(t("errorfetchingdata"));
    } finally {
      setLoading(false);
    }
  };
  const handleRewardHistoryClick = () => {
    navigate("/incentive-rewardshistory");
  };

  const handleAchievementsClick = () => {
    navigate("/incentive-achievementdetails");
  };

  const handleMyWinCardClick = () => {
    navigate("/pay-cards", { state: { cardType: "wincentive" } });
  };

  const handleRedeemButtonClick = async () => {
    await fetchRewardsData();
  
    setRedeemModalOpen(true);
  };

  const handleHbA1cButtonClick = () => {
    setIsModalOpen(true);
  };

  const handleClick = () => {
    // Navigate to the /bhassessment path
    navigate('/bhassessment');
  };

  const handlestoryClick= () => {
    navigate('/incentive-story');
  };

 
  const highrisk = ()=>{
    navigate('/maternity-assessment')
  }
  const handleBackClick = () => {
    navigate('/home');
  };
  const handleHealthmetricsClick= () => {
     setIsSeeVitalModalOpen(true);
  };

  const handleCloseVitalClick = () => {
    setIsSeeVitalModalOpen(false);
    fetchRewardsData();
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
    fetchRewardsData();
    // Optionally, you can reload specific data here if needed
    // For example: reloadBonusGoals();
  };
  
  const formatNumber = (num) => {
    if (num == null) { // Check for null or undefined
      return "0"; // Return default value, e.g., "0" or empty string
    }
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}k`;
    }
    return num.toString();
  };

  const calculateProgress = (current, goal) => Math.min((current / goal) * 100, 100);

  if (loading) {
    return (
     <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  if (error) {
    return <p className="error-message">{error}</p>;
  }

  if (!rewardsData) {
    return <p>{t("norewardsdata")}</p>;
  }

  const {
    WeeklyCheckins = {},
    DailyGoals = {},
    WeeklyGoals = {},
    WeeklyGoalStatus = [],
    BonusCheckins = {},
    TotalRewards = "0.00",
    BonusGoalStatus = [],
  } = rewardsData;

  return (
    <>
      <ToastContainer />
      <div className="col-md-12 col-lg-6 mt-4 d-flex inner-page-heading-wrapper">
        <button className="win-back-btn me-1" onClick={handleBackClick}>
          <span>
            <i className="bi bi-chevron-left"></i> {t("back")}
          </span>
        </button>
        <h2 className="page-heading">{t('rewardstracker')}</h2>
      </div>
      <div className="col-md-12 col-lg-6 mt-4 d-flex justify-content-end flex-sm flex-md-row flex-wrap align-items-center gap-1 win-rewards-button">
        <button className="win-btn-with-icon reward-history-btn" onClick={handleRewardHistoryClick}>
          {t("REWARD HISTORY")}
        </button>
        <button className="win-btn-with-icon achievements-btn ms-3" onClick={handleAchievementsClick}>
          {t("ACHIEVEMENTS")}
        </button>
        <button className="win-btn-with-icon mywincard-btn ms-3" onClick={handleMyWinCardClick}>
          {t("MY WINCARD")}
        </button>
      </div>
      <div className="win-incentive-landing-page">
        <div className="win-incentive-header">
          <p className="earned-label">{t("You've earned")}</p>
          <p className="total-rewards">${TotalRewards}</p>
          <button className="redeem-my-rewards-btn" onClick={handleRedeemButtonClick} >{t("Redeem my WINRewards")}</button>
        </div>

        <div className="win-rewards-note">
          <span>{t('startearning')}</span>
          <br />
          {t('alltakeminutes')}
        </div>

        <div className="row">
          <div className="col-md-6 d-flex justify-content-evenly flex-wrap mt-5">
            <div className="activity-badge-wrapper">
              <div
                className={`activity-badge ${
                  WeeklyCheckins.HealthMetrics === "N" ? " activity-done" : " activity-not-done"
                }`}
              >
                {WeeklyCheckins.HealthMetrics === "N" ? <img src={badgeImage14} alt="Health Metrics" className="wincentive-badge" /> : <img src={badgeImage15} alt="Health Metrics" className="wincentive-badge" />}
              </div>
              {/* <button className={`${WeeklyCheckins.HealthMetrics !== "Y" ? "activity-badge-btn" : "activity-badge-inactive-btn"}`} onClick={handleHealthmetricsClick}>Log your health metrics</button> */}
              <button
              className={`${
                WeeklyCheckins.HealthMetrics !== "N" ? "activity-badge-btn" : "activity-badge-inactive-btn"
              }`}
              onClick={WeeklyCheckins.HealthMetrics !== "N" ? () => handleHealthmetricsClick() : undefined}
              disabled={WeeklyCheckins.HealthMetrics === "N"}
            >
              {t('loghealthmetrics')}
            </button>
            </div>

            <div className="activity-badge-wrapper">
              <div
                className={`activity-badge ${
                  WeeklyCheckins.MentalHealth === "N" ? " activity-done" : " activity-not-done"
                }`}
              >
                {WeeklyCheckins.MentalHealth === "N" ? <img src={badgeImage5} alt="Mental Health Badge" className="wincentive-badge" /> : <img src={badgeImage6} alt="Mental Health Badge" className="wincentive-badge" />}
              </div>
              <button className={`${WeeklyCheckins.MentalHealth !== "N" ? "activity-badge-btn" : "activity-badge-inactive-btn"}`} onClick={WeeklyCheckins.MentalHealth !== "N" ? handleClick : undefined}disabled={WeeklyCheckins.MentalHealth === "N"}> Complete your check-in</button>
            </div>

            <div className="activity-badge-wrapper">
              <div
                className={`activity-badge ${
                  WeeklyCheckins.QuestionPro === "N" ? " activity-done" : " activity-not-done"
                }`}
              >
                {WeeklyCheckins.QuestionPro === "N" ? <img src={badgeImage7} alt="Question Pro" className="wincentive-badge" /> : <img src={badgeImage8} alt="Question Pro" className="wincentive-badge" />}
              </div>
              <button
                className={`${
                  WeeklyCheckins.QuestionPro !== "N" ? "activity-badge-btn" : "activity-badge-inactive-btn"
                }`}
                onClick={WeeklyCheckins.QuestionPro !== "N" ? highrisk : undefined}
                disabled={WeeklyCheckins.QuestionPro === "N"}
              >
                {t('completehealthassessment')}
              </button>
            </div>
          </div>        

          <div className="col-md-6">
            <div className="goals-heading-wrapper">
              <h4 className="goals-heading">{t('daily')} <span> {t('goal')}</span></h4>
            </div>

            <div className="goals-charts-wrapper">
              <div className="goals-progress-chart-wrapper">
                <div className="goals-progress-chart">
                  <CircularProgressbar
                    value={calculateProgress(DailyGoals.DailySteps || 0, 5000)}
                    text={`${formatNumber(DailyGoals.DailySteps || 0)}`}
                    styles={buildStyles({
                      textColor: "#EC008C",
                      pathColor: "#EC008C",
                      trailColor: "#e0e0e0",
                      strokeLinecap: "round",
                    })}
                  />                  
                </div>
                <div className="goals-legends-wrapper">
                  <p>{t('steps')}</p>
                  <p>{DailyGoals.DailySteps}</p>
                </div>
              </div>
              <div className="goals-progress-chart-wrapper">
                <div className="goals-progress-chart">
                  <CircularProgressbar
                    value={calculateProgress(DailyGoals.DailyMins || 0, 30)}
                    text={`${formatNumber(DailyGoals.DailyMins) || 0}`}
                    styles={buildStyles({
                      textColor: "#EC008C",
                      pathColor: "#EC008C",
                      trailColor: "#e0e0e0",
                      strokeLinecap: "round",
                    })}
                  />
                  </div>
                  <div className="goals-legends-wrapper">
                    <p>{t('movements')}</p>
                    <p>{DailyGoals.DailyMins} min</p>
                  </div>
              </div>
            </div>
           
            <div className="goals-heading-wrapper">
              <h4 className="goals-heading">{t('weekly')} <span> {t('goals')}</span></h4>
            </div>
            <div className="goals-charts-wrapper">
              <div className="goals-progress-chart-wrapper">
                <div className="goals-progress-chart">
                  <CircularProgressbar
                    value={calculateProgress(WeeklyGoals.WeeklySteps || 0, 10000)}
                    text={`${formatNumber(WeeklyGoals.WeeklySteps) || 0}`}
                    styles={buildStyles({
                      textColor: "#000000",
                      pathColor: "#000000",
                      trailColor: "#e0e0e0",
                      strokeLinecap: "round",
                    })}
                  />
                </div>
                <div className="goals-legends-wrapper">
                  <p>{t('steps')}</p>
                  <p>{WeeklyGoals.WeeklySteps}</p>
                </div>
              </div>
              <div className="goals-progress-chart-wrapper">
                <div className="goals-progress-chart">
                  <CircularProgressbar
                    value={calculateProgress(WeeklyGoals.WeeklyMins || 0, 30)}
                    text={`${formatNumber(WeeklyGoals.WeeklyMins) || 0}`}
                    styles={buildStyles({
                      textColor: "#000000",
                      pathColor: "#000000",
                      trailColor: "#e0e0e0",
                      strokeLinecap: "round",
                    })}
                  />
                </div>
                <div className="goals-legends-wrapper">
                  <p>{t('movements')}</p>
                  <p>{WeeklyGoals.WeeklyMins}</p>
                </div>
              </div>
            </div>
            
            <div className="goals-list-wrapper">
                {WeeklyGoalStatus.map((goal, index) => (
                  <div className="goals-list-item">
                    <label key={index} className="wincentive-checkbox-wrapper">
                      <input
                        type="checkbox"
                        checked={goal.GoalStatus === "Y"}
                        readOnly
                        className="form-check-input radio-btn win-form-check-input wincent-form-checkbox"
                      />
                      {goal.Goal}
                    </label>
                  </div>
                ))}              
            </div>

            {/* Bonus Goals */}
            <div className="bonus-goals">              
              <div className="goals-heading-wrapper">
                <h4 className="goals-heading">{t('bonus')} <span>{t('goals')}</span></h4>
              </div>
              <div className="row">
                <div className="col-md-6 d-flex justify-content-evenly flex-wrap">
                  <div className="activity-badge-wrapper">
                    <div
                      className={`activity-badge ${
                        BonusCheckins.WinBabyWin === "N" ? " activity-done" : " activity-not-done"
                      }`}
                    >
                      {BonusCheckins.WinBabyWin === "N" ? <img src={badgeImage11} alt="Mental Health Badge" style={{ width: '200px', height: '200px' }} /> : <img src={badgeImage12} alt="Question Pro" className="wincentive-badge" />}

                    </div>
                    <button
                      className={`${
                        BonusCheckins.WinBabyWin !== "N" ? "activity-badge-btn" : "activity-badge-inactive-btn"
                      }`}
                      onClick={BonusCheckins.WinBabyWin !== "N" ? handlestoryClick : undefined}
                      disabled={BonusCheckins.WinBabyWin === "N"}
                    >
                      Share My Story
                    </button>
                  </div>
                </div>
                <div className="col-md-6 d-flex justify-content-evenly flex-wrap">
                  <div className="activity-badge-wrapper">
                    <div
                      className={`activity-badge ${
                        BonusCheckins.HbA1c === "N" ? " activity-done" : " activity-not-done"
                      }`}
                    >
                      {BonusCheckins.HbA1c === "N" ? <img src={badgeImage9} alt="Mental Health Badge" style={{ width: '200px', height: '200px' }} /> : <img src={badgeImage10} alt="Mental Health Badge" style={{ width: '200px', height: '200px' }}/>}
                    </div>
                    
                    <button
                      className={`${
                        BonusCheckins.HbA1c !== "N" ? "activity-badge-btn" : "activity-badge-inactive-btn"
                      }`}
                      onClick={BonusCheckins.HbA1c !== "N" ? () => handleHbA1cButtonClick() : undefined}
                      disabled={BonusCheckins.HbA1c === "N"}
                    >
                      Log now
                    </button>
                  </div>           
              </div>
            </div>
            <div className="goals-list-wrapper">
                {BonusGoalStatus.map((goal, index) => (
                  <div className="goals-list-item">
                    <label key={index} className="wincentive-checkbox-wrapper">
                      <input
                        type="checkbox"
                        checked={goal.GoalStatus === "Y"}
                        readOnly
                        className="form-check-input radio-btn win-form-check-input wincent-form-checkbox"
                      />                    
                      {goal.Goal}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* HbA1c Modal */}
      <WINHbA1cModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        //reloadBonusGoals={reloadBonusGoals}
      />
      {/* Redeem Rewards Modal */}
      <RedeemRewardsModal
          isOpen={isRedeemModalOpen}
          onClose={() => setRedeemModalOpen(false)}
          email={contractData.userData.EmailID}
          setEmail={setEmail}
          amount={amount}
          setAmount={setAmount}
          reloadHistory={fetchRewardsData} // Uncomment this if you want to reload data after redemption
        />
         <VitalsModal
          isOpen={isSeeVitalModalOpen}
          onClose={handleCloseVitalClick}
          trackerType="pregnency"
        />
    </>
  );
};

export default WinIncentiveLandingPage;
